import uniqueId from 'lodash/uniqueId'
import { getPaletteColor } from 'pcln-design-system'
import React, { Component } from 'react'
import styled from 'styled-components'

const defaultProps = {
  bubbleSpace: 30,
}

const SVGContainer = styled.svg`
  display: block;
  height: 20px;
  width: 100%;
  fill: ${(props) =>
    props.color ? getPaletteColor(props.color, 'base')(props) : getPaletteColor('primary.base')(props)};
`

class Loader extends Component {
  constructor(props) {
    super(props)
    this.interval = props.interval || 1.25

    this._MAX_RADIUS = 7.5
    this._MIN_RADIUS = 0
    this._MAX_Y = 20
    this._MIN_Y = 10

    this._circle1_id = uniqueId('loader-circle1-')
    this._circle2_id = uniqueId('loader-circle2-')
    this._circle3_id = uniqueId('loader-circle3-')

    this.state = {
      DOTS_LOADER: null,
    }
  }

  start() {
    let t

    return setInterval(() => {
      t = 0.001 * Date.now()
      this.animate(t)
    }, 1)
  }

  // Bounce interpolation. t and interval should both be in seconds
  bounce(min, max, t) {
    const x = t * Math.PI * (1 / this.interval)
    return max - Math.abs(Math.sin(x) * (max - min))
  }

  scale(min, max, t) {
    const x = t * Math.PI * 2 * (1 / this.interval)
    return Math.min(max, min + (max * 2 - min) * 0.5 * (1 - Math.cos(x)))
  }

  animate(t) {
    this._circle3.setAttribute('cy', this.bounce(this._MIN_Y, this._MAX_Y, t, 10))
    this._circle3.setAttribute('r', this.scale(this._MIN_RADIUS, this._MAX_RADIUS, t, 10))

    this._circle2.setAttribute('cy', this.bounce(this._MIN_Y, this._MAX_Y, t + 0.25, 10))
    this._circle2.setAttribute('r', this.scale(this._MIN_RADIUS, this._MAX_RADIUS, t + 0.25, 10))

    this._circle1.setAttribute('cy', this.bounce(this._MIN_Y, this._MAX_Y, t + 0.5, 10))
    this._circle1.setAttribute('r', this.scale(this._MIN_RADIUS, this._MAX_RADIUS, t + 0.5, 10))
  }

  clearLoadInterval(externalInterval) {
    clearInterval(externalInterval)
  }

  componentDidMount() {
    this._circle1 = document.getElementById(this._circle1_id)
    this._circle2 = document.getElementById(this._circle2_id)
    this._circle3 = document.getElementById(this._circle3_id)

    this.setState({ DOTS_LOADER: this.start() })
  }

  componentWillUnmount() {
    this.clearLoadInterval(this.state.DOTS_LOADER)
  }

  render() {
    return (
      <SVGContainer
        className={this.props.className}
        data-unit-id='LOADER'
        data-testid='LOADER'
        color={this.props.color}
      >
        <g>
          <circle id={this._circle1_id} cx='10' cy='0' r='5' />
        </g>
        <g>
          <circle id={this._circle2_id} cx={10 + this.props.bubbleSpace} cy='0' r='5' />
        </g>
        <g>
          <circle id={this._circle3_id} cx={10 + this.props.bubbleSpace * 2} cy='0' r='5' />
        </g>
      </SVGContainer>
    )
  }
}

Loader.defaultProps = defaultProps
export default Loader
